import {notify} from '@gemcook/notification';

import api from '@api';
import constants from '@constants';
import paths from '@paths';

export const submit = async (
  value: any,
  setSubmitting: React.Dispatch<React.SetStateAction<boolean>>,
  history: any,
  me: MeStore,
  actions: MeAction,
  planDetail: any,
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>,
  setIsFaildModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    setSubmitting(true);
    // 上限人数のチェックを行う
    const users = await api.users.getUsersCount({teamId: me.teamId});
    if (users.count > constants.PLAN.MAX_CAPACITY_COUNT) {
      throw new Error('team capacity is 1000 max');
    }

    // サブスクリプション契約処理
    if (planDetail.value === constants.PLAN.FREE) {
      // サブスクリプション停止処理
      const qp: PaymentDeleteSubscriptioQueryParams = {
        customerId: me.customerId,
      };
      // スタンダードプランから、無料プランへ変更する際にSMSにチェックが入っていた場合、エラーにする
      const teamInfo = await api.teams.getOne(me.teamId);
      if (teamInfo.isSMSSending) {
        throw new Error('must change settings');
      }

      await api.payments.deleteSubscription(qp);
    } else {
      // 新規契約かプラン変更かを判定
      // const isSubscription = await utils.stripe.isSubscription(me.customerId);
      const subscriptionInput: PaymentCreateSubscriptionBody = {
        customerId: me.customerId,
        teamId: me.teamId,
        planId: planDetail.value,
      };
      try {
        await api.payments.createSubscription(subscriptionInput);
      } catch (error) {
        switch (error.response.data.Message) {
          case 'team has no card':
            notify('クレジットカードを登録してください', 'error', undefined, 5);
            break;
        }

        return;
      }
    }

    // チームをを更新
    const teamUpdateInput: TeamsUpdateBody = {
      plan: planDetail.value,
    };

    await api.teams.update(me.teamId, teamUpdateInput);

    // Meを更新
    await actions.me.updateMe();

    await notify('プランを変更しました', 'success');
    history.push(paths.dashboard.main);
  } catch (error) {
    // APIからのエラー
    if (error.response) {
      switch (error.response.data.Message) {
        case 'card was declined':
          setIsModal(false);
          setIsFaildModal(true);
          break;
        case 'team has an unpaid invoice':
          notify(constants.ERRORS.INVALID_CARD, 'error');
          break;
        default: {
          notify(constants.ERRORS.UNKNWON, 'error');
          break;
        }
      }
      return;
    }
    // プラン変更時にフロントのチェックでthrowされたエラー
    switch (error.message) {
      case 'must change settings':
        notify(
          'スタンダードプランから無料プランへご変更いただく場合は、自動送信設定からSMSのチェックを外してください',
          'error',
          undefined,
          5
        );
        break;
      case 'team capacity is 1000 max':
        notify(
          'プランの登録可能上限数を超えてしまいます。ユーザーを削除してください',
          'error',
          undefined,
          5
        );
        break;

      default:
        notify('プランの変更に失敗しました', 'error');
    }
  } finally {
    setSubmitting(false);
  }
};
